export const SKILLS_EVALUATIONS = "/api/all-folders/:param/skills-evaluations"
export const SKILLS_EVALUATION = "/api/all-folders/:param/skills-evaluations/:skillsEvaluationFolderParam"
